<template>
  <v-row>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          <v-row>
            <v-col cols="6">
              Your Affiliate Payments
            </v-col>
            <v-col v-if="!forPrint" cols="6">
              <v-text-field
                v-model="search"
                label="Search"
                class="mx-4"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </gg-card-header>
        <gg-card-text>
          <v-data-table
            :headers="headers"
            :items="payments"
            sort-by="month"
            sort-desc
            :search="search"
            :disable-pagination="forPrint"
            :hide-default-footer="forPrint"
            :loading="pending"
          >
          </v-data-table>
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PaymentsList',
  props: {
    forPrint: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      pending: false,
      search: '',
      headers: [
        { text: 'Commission Month', sortable: true, value: 'month' },
        { text: 'Commission Status', sortable: true, value: 'status' },
        { text: 'Payment Method', sortable: true, value: 'method' },
      ],
    }
  },
  created () {
    this.getHistory()
  },
  computed: {
    ...mapGetters({
      payments: 'affiliates/paymentHistory'
    })
  },
  methods: {
    ...mapActions({
      paymentHistory: 'affiliates/paymentHistory',
      reportError: 'reportError'
    }),
    async getHistory () {
      try {
        this.pending = true
        await this.paymentHistory()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.pending = false
      }
    }
  }
}
</script>
